const SERVICES = [
  {
    icon: 'ri-heart-pulse-line',
    label: 'Veterinary Clinics',
    desc: 'Veterinary services are available in Highlands and nearby towns including Cashiers and Franklin, providing reliable care close to where you\'re staying.',
  },
  {
    icon: 'ri-scissors-cut-line',
    label: 'Pet Grooming',
    desc: 'Grooming services can be found in Highlands and the surrounding area for guests on longer stays or those who prefer their pet looking their best.',
  },
  {
    icon: 'ri-store-2-line',
    label: 'Pet Supplies',
    desc: 'Local retailers and grocery stores in Highlands carry basic pet supplies, and additional options are available in Cashiers and Franklin nearby.',
  },
];

export default function PetServicesSection() {
  return (
    <section className="bg-[#F5F1EB] py-20 px-6 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-[#C9A96E] text-xs tracking-[0.3em] uppercase font-jost mb-4">/ Good to Know</p>
          <h2 className="font-cormorant text-4xl text-[#1A1A18] font-light">
            Pet Services in the<br /><em className="italic">Highlands Area</em>
          </h2>
          <p className="text-[#5C5850] font-jost text-sm mt-5 max-w-xl mx-auto leading-relaxed">
            Traveling with a pet is easy in the Highlands area. Veterinary clinics, grooming services, and pet supplies are available locally and in nearby communities.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-4xl mx-auto">
          {SERVICES.map((s) => (
            <div key={s.label} className="bg-white rounded-2xl p-8 text-center">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#EDE8E0] mx-auto mb-5">
                <i className={`${s.icon} text-[#2D4A3E] text-2xl`} />
              </div>
              <h3 className="font-cormorant text-xl text-[#1A1A18] font-medium mb-3">{s.label}</h3>
              <p className="text-[#5C5850] font-jost text-sm leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>

        <p className="text-center text-[#9C9890] text-xs font-jost mt-8 max-w-2xl mx-auto leading-relaxed">
          For emergency veterinary care, the closest 24-hour animal hospital is located in the Asheville area, approximately 75 miles from Highlands.
        </p>
      </div>
    </section>
  );
}
